export type BriefingPushDeviceInput = {
  storedPushConsent: boolean;
  deviceSupported: boolean;
  deviceSubscribed: boolean;
};

export type BriefingPushDeviceView = {
  preferenceLabel: "Push: on" | "Push: off";
  deviceLabel:
    | "This device: receiving"
    | "This device: not receiving"
    | "This device: unavailable";
  devicePushReady: boolean;
};

export function buildBriefingPushDeviceView(
  input: BriefingPushDeviceInput,
): BriefingPushDeviceView {
  const devicePushReady = input.deviceSupported && input.deviceSubscribed;
  return {
    preferenceLabel: input.storedPushConsent ? "Push: on" : "Push: off",
    deviceLabel: devicePushReady
      ? "This device: receiving"
      : input.deviceSupported
        ? "This device: not receiving"
        : "This device: unavailable",
    devicePushReady,
  };
}
